import { TextField, InputAdornment } from '@mui/material';

export function CustomInput({
  label,
  name,
  id,
  type = 'text',
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  rightSlot,
  focusColor = '#83d84d',
  ...props
}) {
  return (
    <div className="mb-5">
      {label && (
        <label htmlFor={id || name} className="block text-gray-700 text-sm font-medium mb-1.5">
          {label}
        </label>
      )}

      <TextField
        fullWidth
        id={id || name}
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        error={Boolean(error)}
        helperText={helperText}
        size="small"
        InputProps={{
          endAdornment: rightSlot ? (
            <InputAdornment position="end">{rightSlot}</InputAdornment>
          ) : null,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '10px',
            backgroundColor: 'white',
            fontSize: '14px',
            transition: 'all 0.2s',
            '& fieldset': {
              borderColor: error ? '#f87171' : '#d1d5db',
            },
            '&:hover fieldset': {
              borderColor: focusColor,
            },
            '&.Mui-focused fieldset': {
              borderColor: focusColor,
            },
          },
          '& .MuiInputBase-input': {
            padding: '12px 16px',
          },
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
          },
        }}
        {...props}
      />
    </div>
  );
}
